/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomerDepartmentService,
  type Wealthlane_CustomerService_Dtos_CustomerDepartment_UpdateCustomerDepartmentDto,
  type Wealthlane_CustomerService_Dtos_CustomerDepartment_CustomerDepartmentDto,
} from '../../services/wealthlane-customer-services';

const usePostDepartment = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  | Wealthlane_CustomerService_Dtos_CustomerDepartment_CustomerDepartmentDto
  | Wealthlane_CustomerService_Dtos_CustomerDepartment_UpdateCustomerDepartmentDto
  | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          CustomerDepartmentService.putApiCustomerApiAppCustomerDepartmentCustomerDepartment({
            ...payload,
            id,
          })
        );
      }
      return await handleRequest(
        CustomerDepartmentService.postApiCustomerApiAppCustomerDepartmentCustomerDepartment(payload)
      );
    },
    {
      onSuccess: async (
        response:
          | Wealthlane_CustomerService_Dtos_CustomerDepartment_CustomerDepartmentDto
          | Wealthlane_CustomerService_Dtos_CustomerDepartment_UpdateCustomerDepartmentDto
          | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getDepartmentListWithPagination');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Department ${id != null && id != '' ? 'edited.' : 'added.'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostDepartment;
